<p>place-department-input works!</p>
